export const VALID_COMPONENT_TYPES = [
  'navbar',
  'navigation-menu',
  'hero',
  'split-hero',
  'simple-header',
  'features',
  'cta',
  'footer',
  'form',
  'form-split',
  'team',
  'media-text',
  'pricing',
  'video',
  'text-blocks',
  'title-subtitle',
  'contact-info',
  'head-content',
  'body-end',
  'html-embed',
  'html-split',
  'faq',
  'testimonials',
  'countdown-timer',
  'image-gallery',
  'image-info',
  'image-card',
  'promo-banner',
  'logocloud',
  'stats',
  'blog-preview',
  'conversion-popup',
  'compete-form',
] as const;

export const getApiBaseUrl = () => {
  return import.meta.env.VITE_API_BASE_URL || 'https://compete-pages-api.vercel.app';
};
